import { PaReconciliationRecord } from './paReconciliationTypes';

export type PaReconciliationColumnType = 'currency' | 'date' | 'text';

export interface PaReconciliationColumn {
  field: keyof PaReconciliationRecord;
  headerName: string;
  type: PaReconciliationColumnType;
  minWidth: number; // px
  width?: string; // %, used by the flex summary rows (SUMMARY_COLUMNS must add up to 100%)
}

const MONEY_WIDTH = '8.6%';

// Columns of the per-Type summary (Type + 10 money columns; Original Amount and Borrower Paid Fee Amount are only in the invoices table)
export const SUMMARY_COLUMNS: PaReconciliationColumn[] = [
  { field: 'type', headerName: 'Type', type: 'text', minWidth: 170, width: '14%' },
  { field: 'vendorAmountPaid', headerName: 'Vendor Amount Paid', type: 'currency', minWidth: 140, width: MONEY_WIDTH },
  { field: 'investorAmountPaid', headerName: 'Investor Amount Paid', type: 'currency', minWidth: 150, width: MONEY_WIDTH },
  { field: 'investorAmountReimb', headerName: 'Investor Amount Reimb', type: 'currency', minWidth: 150, width: MONEY_WIDTH },
  { field: 'borrowerPaidPaAmount', headerName: 'Borrower Paid PA Amount', type: 'currency', minWidth: 170, width: MONEY_WIDTH },
  { field: 'netPaBalance', headerName: 'Net PA Balance', type: 'currency', minWidth: 140, width: MONEY_WIDTH },
  { field: 'dueToFromVendor', headerName: 'Due to/from Vendor', type: 'currency', minWidth: 150, width: MONEY_WIDTH },
  { field: 'dueToFromInvestor', headerName: 'Due to/from Investor', type: 'currency', minWidth: 150, width: MONEY_WIDTH },
  { field: 'writeoffRch', headerName: 'Writeoff RCH', type: 'currency', minWidth: 120, width: MONEY_WIDTH },
  { field: 'dueToBorrowerRefund', headerName: 'Due to Borrower Refund', type: 'currency', minWidth: 160, width: MONEY_WIDTH },
  { field: 'adjustedPaBalance', headerName: 'Adjusted PA Balance', type: 'currency', minWidth: 150, width: MONEY_WIDTH },
];

// Minimum width (px) of the PA Reconciliation content. Below this the cards stop shrinking (same idea as the
// calculator's table minWidth) so the summary columns stay legible; the dialog scrolls instead.
export const PA_RECONCILIATION_MIN_WIDTH = 1200;

// Columns of the invoices table shown when a Type is selected (the Actions column is added by the table component)
export const INVOICE_COLUMNS: PaReconciliationColumn[] = [
  { field: 'invoice', headerName: 'Invoice', type: 'text', minWidth: 220 },
  { field: 'entity', headerName: 'Vendor', type: 'text', minWidth: 160 },
  { field: 'invoiceDate', headerName: 'Invoice Date', type: 'date', minWidth: 110 },
  { field: 'investor', headerName: 'Investor', type: 'text', minWidth: 140 },
  { field: 'payableStatus', headerName: 'Payable Status', type: 'text', minWidth: 120 },
  { field: 'originalAmount', headerName: 'Original Amount', type: 'currency', minWidth: 130 },
  { field: 'payableAdjustment', headerName: 'Payable Adjustment', type: 'currency', minWidth: 140 },
  { field: 'receivableStatus', headerName: 'Receivable Status', type: 'text', minWidth: 130 },
  { field: 'receivableAmount', headerName: 'Receivable Amount', type: 'currency', minWidth: 140 },
  { field: 'vendorAmountPaid', headerName: 'Vendor Amount Paid', type: 'currency', minWidth: 140 },
  { field: 'vendorPaymentDate', headerName: 'Vendor Paid Date', type: 'date', minWidth: 120 },
  { field: 'investorAmountPaid', headerName: 'Investor Amount Paid', type: 'currency', minWidth: 150 },
  { field: 'investorPaidDate', headerName: 'Investor Paid Date', type: 'date', minWidth: 130 },
  { field: 'investorAmountReimb', headerName: 'Investor Amount Reimb', type: 'currency', minWidth: 150 },
  { field: 'investorReimbDate', headerName: 'Investor Reimb Date', type: 'date', minWidth: 140 },
  { field: 'borrowerPaidPaAmount', headerName: 'Borrower Paid PA Amount', type: 'currency', minWidth: 170 },
  { field: 'netPaBalance', headerName: 'Net PA Balance', type: 'currency', minWidth: 140 },
  { field: 'writeoffRch', headerName: 'Writeoff RCH', type: 'currency', minWidth: 120 },
];
